/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

require('./vendor/jquery.fitvids');
require('./vendor/slick.min');
require('./vendor/picturefill');
require('./vendor/lo-dash-core');

// App Requires
require('./app/config');
require('./app/user');
require('./app/helpers');
require('./app/global');
require('./app/tabs');
require('./app/products');
require('./app/dashboard');
require('./app/blog');
require('./app/calculator');
